import CONFIG from "../config";

let cachedRanks = null;
let fetchPromise = null;

// Default fallback while loading
export const defaultRanks = [
    "Piyoda", "Suvoriy", "Leytinant", "Kapitan", "Mayor",
    "Sharafli", "Kanoner", "General", "Amir", "Rasuljon"
];

export const getRanks = async () => {
    if (cachedRanks) return cachedRanks;

    if (!fetchPromise) {
        fetchPromise = fetch(`${CONFIG.API_BASE_URL}/get_umumiy_baza.php`)
            .then(res => res.json())
            .then(data => {
                if (data.status === 'success' && Array.isArray(data.darajalar)) {
                    cachedRanks = data.darajalar.map(d => d.nomi);
                    return cachedRanks;
                }
                return defaultRanks;
            })
            .catch(err => {
                console.error("Failed to fetch ranks:", err);
                return defaultRanks;
            });
    }

    return fetchPromise;
};
